import { adsenseProvider } from './adsense'
import { _getTestProvider, type AdProvider } from './types'

/** The active ad provider — the scripted test double when injected, else AdSense. */
export function provider(): AdProvider {
  return _getTestProvider() ?? adsenseProvider
}
